// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './ProgramsPage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function ProgramsPage() {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeCategory, setActiveCategory] = useState('All');

//   const programsData = [
//     // --- UG Programs ---
//     {
//       id: 1,
//       title: 'Bachelor of Arts (BA)',
//       type: 'UG',
//       typeLabel: 'UG',
//       duration: '3 Years',
//       eligibility: '10+2 Pass in any stream',
//       medium: 'Tamil / English',
//       annualFee: '₹4,800/yr',
//       totalFee: '₹14,400',
//       tags: 'Tamil, English, History, Economics, Political Science',
//       themeClass: 'theme-ug'
//     },
//     {
//       id: 2,
//       title: 'Bachelor of Commerce (BCom)',
//       type: 'UG',
//       typeLabel: 'UG',
//       duration: '3 Years',
//       eligibility: '10+2 with Commerce / any stream',
//       medium: 'Tamil / English',
//       annualFee: '₹5,200/yr',
//       totalFee: '₹15,600',
//       tags: 'Accountancy, Business Law, Statistics',
//       themeClass: 'theme-ug'
//     },
//     {
//       id: 3,
//       title: 'Bachelor of Business Administration (BBA)',
//       type: 'UG',
//       typeLabel: 'UG',
//       duration: '3 Years',
//       eligibility: '10+2 Pass',
//       medium: 'English',
//       annualFee: '₹6,000/yr',
//       totalFee: '₹18,000',
//       tags: 'Management, Marketing, Finance, HRM',
//       themeClass: 'theme-ug'
//     },
//     {
//       id: 4,
//       title: 'Bachelor of Computer Applications (BCA)',
//       type: 'UG',
//       typeLabel: 'UG',
//       duration: '3 Years',
//       eligibility: '10+2 Pass (with/without Maths)',
//       medium: 'English',
//       annualFee: '₹7,500/yr',
//       totalFee: '₹22,500',
//       tags: 'Programming, Database, Networking, Web Technologies',
//       themeClass: 'theme-ug'
//     },
//     {
//       id: 5,
//       title: 'Bachelor of Science – Computer Science (BSc CS)',
//       type: 'UG',
//       typeLabel: 'UG',
//       duration: '3 Years',
//       eligibility: '10+2 with Maths',
//       medium: 'English',
//       annualFee: '₹6,500/yr',
//       totalFee: '₹19,500',
//       tags: 'C++, Java, Data Structures, OS',
//       themeClass: 'theme-ug'
//     },
//     {
//       id: 6,
//       title: 'Bachelor of Science – Mathematics (BSc Maths)',
//       type: 'UG',
//       typeLabel: 'UG',
//       duration: '3 Years',
//       eligibility: '10+2 with Maths',
//       medium: 'Tamil / English',
//       annualFee: '₹5,500/yr',
//       totalFee: '₹16,500',
//       tags: 'Calculus, Algebra, Statistics',
//       themeClass: 'theme-ug'
//     },

//     // --- PG Programs ---
//     {
//       id: 7,
//       title: 'Master of Arts – English (MA English)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'Any UG Degree',
//       medium: 'English',
//       annualFee: '₹6,000/yr',
//       totalFee: '₹12,000',
//       tags: 'Literature, Linguistics, Communication',
//       themeClass: 'theme-pg'
//     },
//     {
//       id: 8,
//       title: 'Master of Arts – Tamil (MA Tamil)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'Any UG Degree',
//       medium: 'Tamil',
//       annualFee: '₹5,500/yr',
//       totalFee: '₹11,000',
//       tags: 'Tamil Literature, Grammar, Culture',
//       themeClass: 'theme-pg'
//     },
//     {
//       id: 9,
//       title: 'Master of Commerce (MCom)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'BCom / BBA',
//       medium: 'Tamil / English',
//       annualFee: '₹6,500/yr',
//       totalFee: '₹13,000',
//       tags: 'Advanced Accountancy, Taxation, Finance',
//       themeClass: 'theme-pg'
//     },
//     {
//       id: 10,
//       title: 'Master of Business Administration (MBA)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'Any UG Degree',
//       medium: 'English',
//       annualFee: '₹12,000/yr',
//       totalFee: '₹24,000',
//       tags: 'Strategy, Marketing, Finance, Operations',
//       themeClass: 'theme-pg'
//     },
//     {
//       id: 11,
//       title: 'Master of Computer Applications (MCA)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'BCA / BSc(CS) / BSc(IT)',
//       medium: 'English',
//       annualFee: '₹14,000/yr',
//       totalFee: '₹28,000',
//       tags: 'Advanced Programming, AI, Cloud Computing',
//       themeClass: 'theme-pg'
//     },
//     {
//       id: 12,
//       title: 'Master of Science – Computer Science (MSc CS)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'BSc CS / BCA',
//       medium: 'English',
//       annualFee: '₹8,000/yr',
//       totalFee: '₹16,000',
//       tags: 'Machine Learning, Algorithms, Research Methods',
//       themeClass: 'theme-pg'
//     },
//     {
//       id: 13,
//       title: 'Master of Social Work (MSW)',
//       type: 'PG',
//       typeLabel: 'PG',
//       duration: '2 Years',
//       eligibility: 'Any UG Degree',
//       medium: 'Tamil / English',
//       annualFee: '₹7,000/yr',
//       totalFee: '₹14,000',
//       tags: 'Community Development, Counseling, Social Policy',
//       themeClass: 'theme-pg'
//     },

//     // --- Diploma Programs ---
//     {
//       id: 14,
//       title: 'PG Diploma in Computer Applications (PGDCA)',
//       type: 'Diploma',
//       typeLabel: 'Diploma',
//       duration: '1 Year',
//       eligibility: 'Any UG Degree',
//       medium: 'English',
//       annualFee: '₹5,000',
//       totalFee: '₹5,000',
//       tags: 'MS Office, Programming, Database, Internet',
//       themeClass: 'theme-dip'
//     },
//     {
//       id: 15,
//       title: 'PG Diploma in Business Management (PGDBM)',
//       type: 'Diploma',
//       typeLabel: 'Diploma',
//       duration: '1 Year',
//       eligibility: 'Any UG Degree',
//       medium: 'English',
//       annualFee: '₹5,000',
//       totalFee: '₹5,000',
//       tags: 'Management Principles, HR, Marketing',
//       themeClass: 'theme-dip'
//     },
//     {
//       id: 16,
//       title: 'PG Diploma in Journalism (PGDJ)',
//       type: 'Diploma',
//       typeLabel: 'Diploma',
//       duration: '1 Year',
//       eligibility: 'Any UG Degree',
//       medium: 'Tamil / English',
//       annualFee: '₹4,500',
//       totalFee: '₹4,500',
//       tags: 'Reporting, Editing, Media Ethics',
//       themeClass: 'theme-dip'
//     },

//     // --- Certificate Programs ---
//     {
//       id: 17,
//       title: 'Certificate in Spoken English',
//       type: 'Certificate',
//       typeLabel: 'Certificate',
//       duration: '6 Months',
//       eligibility: '10th Pass',
//       medium: 'English',
//       annualFee: '₹2,500',
//       totalFee: '₹2,500',
//       tags: 'Speaking, Listening, Grammar',
//       themeClass: 'theme-cert'
//     },
//     {
//       id: 18,
//       title: 'Certificate in Computer Applications',
//       type: 'Certificate',
//       typeLabel: 'Certificate',
//       duration: '6 Months',
//       eligibility: '10th Pass',
//       medium: 'Tamil / English',
//       annualFee: '₹2,500',
//       totalFee: '₹2,500',
//       tags: 'Computer Basics, MS Office, Internet',
//       themeClass: 'theme-cert'
//     },
//     {
//       id: 19,
//       title: 'Certificate in Journalism & Mass Communication',
//       type: 'Certificate',
//       typeLabel: 'Certificate',
//       duration: '6 Months',
//       eligibility: '10+2 Pass',
//       medium: 'Tamil / English',
//       annualFee: '₹3,000',
//       totalFee: '₹3,000',
//       tags: 'Journalism, Photography, Media Writing',
//       themeClass: 'theme-cert'
//     }
//   ];

//   // Filtering Logic based on Search Term & Active Category
//   const filteredPrograms = programsData.filter((item) => {
//     const matchesSearch =
//       item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.tags.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.eligibility.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesCategory =
//       activeCategory === 'All' || item.type === activeCategory;

//     return matchesSearch && matchesCategory;
//   });

//   const categories = ['All', 'UG', 'PG', 'Diploma', 'Certificate'];

//   return (
//       <>
//          <Navbar />
//     <div className="programs-page-wrapper">
      
//       {/* 1. Header Banner */}
//       <section className="programs-hero-banner">
//         <div className="banner-inner-container">
//           <nav className="breadcrumb-nav">
//             <Link to="/" className="breadcrumb-link">Home</Link> / <span>Programs</span>
//           </nav>
//           <h1>Programs Offered</h1>
//           <p>Academic Year 2025–26 | UG, PG, Diploma &amp; Certificate Programs</p>
//         </div>
//       </section>

//       {/* 2. Filter & Search Control Section */}
//       <section className="programs-control-section">
//         <div className="programs-container">
          
//           <div className="filter-bar-wrapper">
//             {/* Search Input */}
//             <div className="search-input-box">
//               <span className="search-icon">🔍</span>
//               <input
//                 type="text"
//                 placeholder="Search programs..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>

//             {/* Category Filter Pills */}
//             <div className="category-filter-group">
//               {categories.map((cat) => (
//                 <button
//                   key={cat}
//                   className={`filter-pill ${activeCategory === cat ? 'active-pill' : ''}`}
//                   onClick={() => setActiveCategory(cat)}
//                 >
//                   {cat}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Results Count Metadata */}
//           <div className="results-count-text">
//             {filteredPrograms.length} programs found
//           </div>

//         </div>
//       </section>

//       {/* 3. Programs Cards Grid */}
//       <section className="programs-grid-section">
//         <div className="programs-container">
          
//           {filteredPrograms.length > 0 ? (
//             <div className="programs-cards-grid">
//               {filteredPrograms.map((program) => (
//                 <div key={program.id} className={`program-card ${program.themeClass}`}>
                  
//                   {/* Top Bar Indicator */}
//                   <div className="card-top-accent"></div>

//                   <div className="card-body-content">
//                     <div className="card-header-row">
//                       <h3 className="program-title">{program.title}</h3>
//                       <span className="type-badge">{program.typeLabel}</span>
//                     </div>

//                     {/* Meta Specifications */}
//                     <div className="spec-details-list">
//                       <div className="spec-row">
//                         <span className="spec-label">Duration:</span>
//                         <span className="spec-val font-semibold">{program.duration}</span>
//                       </div>
//                       <div className="spec-row">
//                         <span className="spec-label">Eligibility:</span>
//                         <span className="spec-val align-right">{program.eligibility}</span>
//                       </div>
//                       <div className="spec-row">
//                         <span className="spec-label">Medium:</span>
//                         <span className="spec-val">{program.medium}</span>
//                       </div>
//                       <div className="spec-row">
//                         <span className="spec-label">Annual Fee:</span>
//                         <span className="spec-val highlight-bold">{program.annualFee}</span>
//                       </div>
//                       <div className="spec-row">
//                         <span className="spec-label">Total Fee:</span>
//                         <span className="spec-val highlight-bold">{program.totalFee}</span>
//                       </div>
//                     </div>

//                     {/* Course Sub-topics / Tags */}
//                     <p className="tags-footer-text">{program.tags}</p>

//                     {/* Apply Now Button */}
//                     <a href="#apply" className="btn-card-apply">
//                       Apply Now <span className="arrow-icon">➔</span>
//                     </a>
//                   </div>

//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="no-results-box">
//               <h3>No programs matched your search criteria.</h3>
//               <p>Try clearing your search input or switching filter categories.</p>
//             </div>
//           )}

//         </div>
//       </section>

//     </div>
//       <FooterSection/>
//             </>
//   );
// }

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProgramsPage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

export default function ProgramsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const [programsData, setProgramsData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Helper function to map DB program_type to UI filter categories & themes
  const getCategoryTheme = (typeStr) => {
    const type = typeStr ? typeStr.toUpperCase() : '';
    if (type.includes('UNDER-GRADUATE') || type === 'UG') {
      return { type: 'UG', typeLabel: 'UG', themeClass: 'theme-ug' };
    } else if (type.includes('POST-GRADUATE') || type === 'PG') {
      return { type: 'PG', typeLabel: 'PG', themeClass: 'theme-pg' };
    } else if (type.includes('DIPLOMA')) {
      return { type: 'Diploma', typeLabel: 'Diploma', themeClass: 'theme-dip' };
    } else if (type.includes('CERTIFICATE')) {
      return { type: 'Certificate', typeLabel: 'Certificate', themeClass: 'theme-cert' };
    }
    return { type: 'UG', typeLabel: 'UG', themeClass: 'theme-ug' };
  };

  // Fetch courses from Express API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const result = await response.json();

        if (result.success) {
          const formattedData = result.data.map((course) => {
            const { type, typeLabel, themeClass } = getCategoryTheme(course.program_type);
            
            // Format duration string
            const dur = parseInt(course.minimum_duration);
            const durationText = dur >= 1 ? `${dur} Year${dur > 1 ? 's' : ''}` : `${course.minimum_duration} Months`;

            // Calculate fee metrics
            const annualFeeNum = parseFloat(course.total_course_fee) || 0;
            const years = dur >= 1 ? dur : 1;
            const totalFeeNum = annualFeeNum ;

            return {
              id: course.id,
              code: course.course_code,
              title: course.course_name,
              type: type,
              typeLabel: typeLabel,
              duration: durationText,
              eligibility: course.eligibility || 'As per University Norms',
              medium: course.course_medium,
              annualFee: `₹${annualFeeNum.toLocaleString('en-IN')}`,
              totalFee: `₹${totalFeeNum.toLocaleString('en-IN')}`,
              themeClass: themeClass
            };
          });

          setProgramsData(formattedData);
        }
      } catch (error) {
        console.error('Failed to fetch courses from API:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  // Filtering Logic based on Search Term & Active Category
  const filteredPrograms = programsData.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.eligibility.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory =
      activeCategory === 'All' || item.type === activeCategory;

    return matchesSearch && matchesCategory;
  });

  const categories = ['All', 'UG', 'PG', 'Diploma', 'Certificate'];

  return (
    <>
      <Navbar />
      <div className="programs-page-wrapper">
        
        {/* 1. Header Banner */}
        <section className="programs-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Programs</span>
            </nav>
            <h1>Programs Offered</h1>
            <p>Academic Year 2025–26 | UG, PG, Diploma &amp; Certificate Programs</p>
          </div>
        </section>

        {/* 2. Filter & Search Control Section */}
        <section className="programs-control-section">
          <div className="programs-container">
            
            <div className="filter-bar-wrapper">
              {/* Search Input */}
              <div className="search-input-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  placeholder="Search programs..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Category Filter Pills */}
              <div className="category-filter-group">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`filter-pill ${activeCategory === cat ? 'active-pill' : ''}`}
                    onClick={() => setActiveCategory(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>

            {/* Results Count Metadata */}
            <div className="results-count-text">
              {loading ? 'Loading programs...' : `${filteredPrograms.length} programs found`}
            </div>

          </div>
        </section>

        {/* 3. Programs Cards Grid */}
        <section className="programs-grid-section">
          <div className="programs-container">
            
            {loading ? (
              <div className="no-results-box">
                <h3>Loading programs, please wait...</h3>
              </div>
            ) : filteredPrograms.length > 0 ? (
              <div className="programs-cards-grid">
                {filteredPrograms.map((program) => (
                  <div key={program.id} className={`program-card ${program.themeClass}`}>
                    
                    {/* Top Bar Indicator */}
                    <div className="card-top-accent"></div>

                    <div className="card-body-content">
                      <div className="card-header-row">
                        <h3 className="program-title">{program.title}</h3>
                        <span className="type-badge">{program.typeLabel}</span>
                      </div>

                      {/* Meta Specifications */}
                      <div className="spec-details-list">
                        <div className="spec-row">
                          <span className="spec-label">Duration:</span>
                          <span className="spec-val font-semibold">{program.duration}</span>
                        </div>
                        <div className="spec-row">
                          <span className="spec-label">Eligibility:</span>
                          <span className="spec-val align-right">{program.eligibility}</span>
                        </div>
                        <div className="spec-row">
                          <span className="spec-label">Medium:</span>
                          <span className="spec-val">{program.medium}</span>
                        </div>
                        {/* <div className="spec-row">
                          <span className="spec-label"> Fee:</span>
                          <span className="spec-val highlight-bold">{program.annualFee}</span>
                        </div>
                        <div className="spec-row">
                          <span className="spec-label">Total Fee:</span>
                          <span className="spec-val highlight-bold">{program.totalFee}</span>
                        </div> */}
                      </div>

                      {/* Course Sub-topics / Tags (Commented out for dynamic DB integration) */}
                      {/* <p className="tags-footer-text">{program.tags}</p> */}

                      {/* Apply Now Button */}
                      <a href="/contact-enquiry" className="btn-card-apply">
                        Apply Now <span className="arrow-icon">➔</span>
                      </a>
                    </div>

                  </div>
                ))}
              </div>
            ) : (
              <div className="no-results-box">
                <h3>No programs matched your search criteria.</h3>
                <p>Try clearing your search input or switching filter categories.</p>
              </div>
            )}

          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}